import { render, staticRenderFns } from "./SsoStepUpWrapper.vue?vue&type=template&id=f5434b26&"
import script from "./SsoStepUpWrapper.vue?vue&type=script&lang=ts&"
export * from "./SsoStepUpWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports